// extracted by mini-css-extract-plugin
export default {"label":"TimeZone_label__JV-oF","timeZone":"TimeZone_timeZone__eGCal"};